import React, { useContext, useEffect, useState } from "react";
import { getDataWithToken } from "../../services/GetDataService";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TablePagination from "@mui/material/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { AuthContext } from "../../context/AuthContext";
import { Box, TableContainer } from "@mui/material";
import Grid from "@mui/material/Grid2";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import AddCustomerSuggestionComplaint from "./AddCustomerSuggestionComplaint";
import UpdateCustomerSuggestionComplaint from "./UpdateCustomerSuggestionComplaint";

const CustomerSuggestionComplaintList = () => {
  const { ifixit_admin_panel, logout } = useContext(AuthContext);
  const [tableDataList, setTableDataList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const handleSnakbarOpen = (msg, vrnt) => {
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: vrnt === "error" ? 3000 : 1000,
    });
  };

  const customeTextFeild = {
    "& label": {
      fontSize: "11px",
    },
    "& label.Mui-focused": {
      color: "#0F1624",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 12px",
    },
    "& .MuiOutlinedInput-root": {
      fontSize: "13px",
      "& fieldset": {
        borderRadius: "8px",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const pageLoading = () => {
    const loadingNumber = ifixit_admin_panel?.user?.permission?.includes(
      "update_customer_suggestion_complaint",
    )
      ? 11
      : 10;

    return [...Array(10).keys()].map((item) => (
      <TableRow key={item}>
        {[...Array(loadingNumber).keys()].map((cell) => (
          <TableCell key={cell}>
            <Skeleton />
          </TableCell>
        ))}
      </TableRow>
    ));
  };

  const clearFilter = () => {
    setEmail("");
    setMobile("");
    setType("");
    setStatus("");
    setPage(0);

    const newUrl = `/api/v1/customerSuggestionComplaint?limit=${rowsPerPage}&page=1`;
    getData(0, rowsPerPage, newUrl);
  };

  const handleChangePage = (event, newPage) => {
    getData(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, rowsPerPage));
    getData(0, event.target.value);
    setPage(0);
  };

  const getData = async (pageNO, limit, newUrl) => {
    setLoading(true);
    let newPageNO = page;
    let url;

    if (pageNO >= 0) {
      newPageNO = pageNO;
    }

    let newLimit = rowsPerPage;
    if (limit) {
      newLimit = limit;
    }

    if (newUrl) {
      url = newUrl;
    } else {
      let newStatus = status;
      if (status === "None") {
        newStatus = "";
      }

      url = `/api/v1/customerSuggestionComplaint?email=${email.trim()}&mobile=${mobile.trim()}&type=${type.trim()}&status=${newStatus}&limit=${newLimit}&page=${
        newPageNO + 1
      }`;
    }

    const allData = await getDataWithToken(url);

    if (allData?.status === 401) {
      logout();
      return;
    }

    if (allData.status >= 200 && allData.status < 300) {
      setTableDataList(allData?.data?.data);
      setTotalData(allData?.data?.totalData);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      handleSnakbarOpen(allData?.data?.message, "error");
    }

    setLoading(false);
  };

  const formatDate = (date) => {
    return date ? dayjs(date).format("DD MMM YYYY") : "---------";
  };

  const formatUser = (row, key) => {
    return (
      row?.[`${key}_data`]?.[0]?.name ||
      row?.[`${key}_data`]?.[0]?.email ||
      row?.[key] ||
      "---------"
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Grid container columnSpacing={3} style={{ padding: "24px 0" }}>
        <Grid size={6}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{ color: "#0F1624", fontWeight: 600 }}
          >
            Customer Suggestion Complaint List
          </Typography>
        </Grid>
        <Grid size={6} style={{ textAlign: "right" }}>
          {/* {ifixit_admin_panel?.user?.permission?.includes(
            "add_customer_suggestion_complaint",
          ) && <AddCustomerSuggestionComplaint clearFilter={clearFilter} />} */}
        </Grid>
      </Grid>

      <div
        style={{
          background: "#fff",
          border: "1px solid #EAECF1",
          borderRadius: "12px",
          overflow: "hidden",
          padding: "16px 0",
          boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{ px: 1.5, mb: 1.75 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 2, xl: 2 }}>
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{ color: "#0F1624", fontWeight: 600, margin: 0 }}
            >
              Details
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                justifyContent="right"
                alignItems="center"
                spacing={1}
              >
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 2, xl: 2 }}>
                  <TextField
                    sx={{ ...customeTextFeild }}
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 2, xl: 2 }}>
                  <TextField
                    sx={{ ...customeTextFeild }}
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Mobile"
                    inputProps={{ maxLength: 11 }}
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 2, xl: 2 }}>
                  <TextField
                    sx={{ ...customeTextFeild }}
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Type"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 2, xl: 2 }}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ ...customeTextFeild }}
                  >
                    <InputLabel id="customer-suggestion-complaint-status-filter-label">
                      Status
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="customer-suggestion-complaint-status-filter-label"
                      label="Status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value="None">None</MenuItem>
                      <MenuItem value={true}>Active</MenuItem>
                      <MenuItem value={false}>Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 2, xl: 2 }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={{ lg: 1, xl: 1 }}>
                      <Grid size={4}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="info"
                          disableElevation
                          size="small"
                          sx={{ py: "4px" }}
                          onClick={clearFilter}
                        >
                          <RestartAltIcon />
                        </Button>
                      </Grid>
                      <Grid size={8}>
                        <Button
                          fullWidth
                          variant="contained"
                          disableElevation
                          color="info"
                          sx={{ py: "4px" }}
                          size="small"
                          startIcon={<SearchIcon />}
                          onClick={(event) => handleChangePage(event, 0)}
                        >
                          Search
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <div
          style={{
            overflowX: "auto",
            minWidth: "100%",
            width: "Calc(100vw - 385px)",
            boxSizing: "border-box",
          }}
        >
          <TableContainer sx={{ maxHeight: "Calc(100vh - 250px)" }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ whiteSpace: "nowrap" }}>Email</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Mobile Number
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>Type</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Description
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Remarks
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>Status</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Created At
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Updated At
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Created By
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Updated By
                  </TableCell>
                  {ifixit_admin_panel?.user?.permission?.includes(
                    "update_customer_suggestion_complaint",
                  ) && (
                    <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                      Actions
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {!loading &&
                  tableDataList.length > 0 &&
                  tableDataList.map((row, i) => (
                    <TableRow
                      key={i}
                      sx={
                        row?.is_read_by_admin === false && {
                          backgroundColor: "#f3f3f3",
                        }
                      }
                    >
                      <TableCell>
                        {row?.email ? row?.email : "---------"}
                      </TableCell>
                      <TableCell>
                        {row?.mobile ? row?.mobile : "---------"}
                      </TableCell>
                      <TableCell>
                        {row?.type ? row?.type : "---------"}
                      </TableCell>
                      <TableCell sx={{ minWidth: "180px" }}>
                        {row?.description ? row?.description : "---------"}
                      </TableCell>
                      <TableCell sx={{ minWidth: "150px" }}>
                        {row?.remarks ? row?.remarks : "---------"}
                      </TableCell>
                      <TableCell>
                        {row?.status ? (
                          <>
                            <TaskAltOutlinedIcon
                              style={{
                                color: "#10ac84",
                                height: "16px",
                                position: "relative",
                                top: "4px",
                              }}
                            />{" "}
                            <span style={{ color: "#10ac84" }}>
                              Active &nbsp;
                            </span>
                          </>
                        ) : (
                          <>
                            <HighlightOffOutlinedIcon
                              style={{
                                color: "#ee5253",
                                height: "16px",
                                position: "relative",
                                top: "4px",
                              }}
                            />
                            <span style={{ color: "#ee5253" }}>Inactive</span>
                          </>
                        )}
                      </TableCell>
                      <TableCell>{formatDate(row?.created_at)}</TableCell>
                      <TableCell>{formatDate(row?.updated_at)}</TableCell>
                      <TableCell>{formatUser(row, "created_by")}</TableCell>
                      <TableCell>{formatUser(row, "updated_by")}</TableCell>
                      {ifixit_admin_panel?.user?.permission?.includes(
                        "update_customer_suggestion_complaint",
                      ) && (
                        <TableCell align="right">
                          <UpdateCustomerSuggestionComplaint
                            clearFilter={clearFilter}
                            row={row}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  ))}

                {!loading && tableDataList.length < 1 ? (
                  <TableRow>
                    <TableCell colSpan={11} style={{ textAlign: "center" }}>
                      <strong>{message}</strong>
                    </TableCell>
                  </TableRow>
                ) : null}
                {loading && pageLoading()}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        {tableDataList.length > 0 ? (
          <div>
            <TablePagination
              style={{ display: "block", border: "none" }}
              rowsPerPageOptions={[]}
              count={totalData}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        ) : (
          <br />
        )}
      </div>
    </>
  );
};

export default CustomerSuggestionComplaintList;
